import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";

const Note = (props) => {
  return (
    <Grid container direction="column">
      <Grid item style={{ height: "25px" }}>
        <Grid container>
          <Grid item xs={6} className="bold-500 text-87">
            {props.author}
          </Grid>
          <Grid item xs={6} className="bold-500" style={{ textAlign: "right" }}>
            {props.date}
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
      <Grid item xs={6}  className="text-38">
            {props.related && (
             
                "[" + I18n.get("site_" + props.related) + "]"
             
            )}
             </Grid>
             {props.noteType &&<Grid item xs={6} style={{ textAlign: "right" }}>
               {props.noteType}
             </Grid>}
      </Grid>
      <Grid item className="text-54" style={{ textAlign: "justify" }}>
        {props.description}
      </Grid>
    </Grid>
  );
};

Note.propTypes = {
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  noteType:PropTypes.string
};

export default Note;
